<template>
  <div class="page-container">
    <div class="page-content">
      <!-- Cabeçalho -->
      <div class="page-header">
        <div class="d-flex align-items-center mb-3">
          <h1 class="text-white">
            <i class="mdi mdi-cash-percent"></i> Comissão
          </h1>
          <div class="ml-auto">
            <button
              type="button"
              class="btn btn-outline-white"
              v-b-toggle.collapse-filter
            >
              <span class="mr-2">Filtros</span>
              <i class="fa fa-angle-up status-icon"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Collapse de Filtros -->
      <b-collapse id="collapse-filter" class="mb-3">
        <div class="card bg-light-gray p-3">
          <div class="d-flex">
            <b-form-input
              v-model="filter"
              placeholder="Digite o que deseja buscar"
              class="mr-2 flex-grow-1"
            />
            <b-button variant="primary" @click="applyFilter">Buscar</b-button>
            <b-button variant="secondary" class="ml-2" @click="clearFilter">
              Limpar
            </b-button>
          </div>
        </div>
      </b-collapse>

      <!-- Alertas -->
      <div v-if="alertMessage" class="col-12 mb-2">
        <b-alert show variant="danger">{{ alertMessage }}</b-alert>
      </div>

      <!-- Overlay de Loading -->
      <div
        v-if="loading"
        class="overlay-modal d-flex align-items-center justify-content-center mb-3"
      >
        <b-spinner label="Carregando..."></b-spinner>
      </div>

      <!-- Card com Tabela -->
      <div class="card bg-light-gray">
        <div class="card-body pt-1">
          <div class="table-responsive">
            <table
              class="table-v3 w-100 text-center"
              role="table"
              aria-busy="false"
            >
              <thead role="rowgroup">
                <tr role="row">
                  <th class="nowrap">ID</th>
                  <th class="nowrap">Seguradora</th>
                  <th class="nowrap">Percentual da Comissão</th>
                  <th class="nowrap">Ações</th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                <tr
                  v-for="(item, index) in commissions"
                  :key="index"
                  role="row"
                >
                  <td role="cell" class="font-12">{{ item.id }}</td>
                  <td role="cell" class="font-12 text-left">
                    <span v-if="item.no_logo">
                      {{ translateInsurerIdentifierTypes[item.insurer] }}
                    </span>
                    <img
                      v-else
                      :src="item.insurer_icon"
                      class="insurance-logo"
                      @error="imageLoadError(index)"
                    />
                  </td>
                  <td role="cell" class="font-12">{{ item.percentage }}%</td>
                  <td role="cell" class="font-12">
                    <button
                      class="btn btn-action"
                      @click="openModal(item)"
                      v-b-tooltip.hover
                      title="Editar"
                    >
                      <i class="fas fa-pen"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
              <nav aria-label="Paginação" class="mt-4">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  @change="pageChanged"
                  aria-controls="my-table"
                ></b-pagination>
              </nav>
          </div>

        </div>
      </div>

      <!-- Modal de Edição -->
      <commission-modal ref="commissionModal" @save="saveCommission" />
    </div>
  </div>
</template>


<script>
import { CommissionModal } from "@/components/Commission";
import commissionService from "@/services/commission";
import translateInsurerIdentifierTypes from "@/enums/translate/insurerIdentifierTypes";

export default {
  name: "ListCommission",
  components: { CommissionModal },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      commissions: [],
      filter: null,
      loading: false,
      totalRows: 0,
      translateInsurerIdentifierTypes: translateInsurerIdentifierTypes,
    };
  },
   computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalRows / this.perPage));
    },
    pages() {
      const t = this.totalPages;
      if (t <= 3) return Array.from({ length: t }, (_, i) => i + 1);
      if (this.currentPage === 1) return [1, 2, 3];
      if (this.currentPage === t) return [t - 2, t - 1, t];
      return [this.currentPage - 1, this.currentPage, this.currentPage + 1];
    },
  },
  created() {
    this.getCommissions();
  },
  methods: {
    openModal(item) {
      this.$refs.commissionModal.open(item);
    },
    saveCommission(data) {
      this.store(data);
      this.getCommissions();
    },
    pageChanged(page) {
      this.currentPage = page;
      this.getCommissions();
    },
    clearFilter() {
      this.filter = "";
      this.getCommissions();
    },
    applyFilter() {
      this.currentPage = 1;
      this.getCommissions();
    },
       changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.getCommissions();
    },
    getCommissions() {
      this.loading = true;
      commissionService
        .get({
          page: this.currentPage,
          per_page: this.perPage,
          filter: this.filter,
        })
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.commissions = response.data.data;
          this.totalRows = response.data.total;
        })
        .catch(() => {
          this.showError("Não foi possível recuperar a lista de seguradoras.");
        }).finally(() => {
          this.loading = false;
        });
    },
    store(data) {
      commissionService
        .update(data.id, data)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
        })
        .catch(() => {
          this.showError("Não foi possível recuperar a lista de seguradoras.");
        }).finally(() => {
          this.getCommissions();
        });
    },
    imageLoadError(idx) {
      this.$set(this.commissions[idx], "no_logo", true);
    }
  }
};
</script>

<style scoped>

</style>
